import http from "./httpService"
import { oneLoungeApi } from "../config.json"

const apiEndpoint = `${oneLoungeApi}/company/getCompanyByVatNo` // set url here

export function getCompanyByVatNr(vatNr) {
  return http.get(`${apiEndpoint}?vatNo=${vatNr}`)
}
